// ownershipEndpoints.ts
// API endpoints for ownership snapshot data (S13)

import { apiClient } from './client';

// Types
export interface OwnershipEntry {
  user_id: string;
  full_name: string;
  email: string;
  base_principal_cents: number;
  base_principal_dollars: string;
  ownership_percent: string;
  participation_status?: string; // S42: For filtering active/closed
}

export interface CurrentOwnershipResponse {
  total_pool_cents: number;
  total_pool_dollars: string;
  as_of: string | null;
  entries: OwnershipEntry[];
}

export interface OwnershipSnapshot {
  as_of: string;
  total_pool_cents: number;
  total_pool_dollars: string;
  entries: OwnershipEntry[];
}

export interface OwnershipHistoryResponse {
  snapshots: OwnershipSnapshot[];
}

// Endpoints
const ownershipEndpoints = {
  /**
   * Get current ownership snapshot with Total Pool and per-user ownership percentages
   * @param status - Filter by participation status: 'active', 'closed', or undefined for all
   */
  getCurrent: async (status?: 'active' | 'closed'): Promise<CurrentOwnershipResponse> => {
    const params = status ? `?status=${status}` : '';
    return apiClient.get<CurrentOwnershipResponse>(`/read/ownership/current${params}`);
  },

  /**
   * Get historical ownership snapshots
   * @param limit - Number of snapshots to return (default: 50, max: 200)
   */
  getHistory: async (limit: number = 50): Promise<OwnershipHistoryResponse> => {
    return apiClient.get<OwnershipHistoryResponse>(`/read/ownership/history?limit=${limit}`);
  },
};

export default ownershipEndpoints;
